module.exports = __webpack_public_path__ + "static/media/woman.4d988ca2.jpg";